
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type sortDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function sortDialogRT(): TemplateResult<sortDialogRTRootProps> {
    function repeatSortOption1(currentSort, sortOption, sortOptionIndex) {
        return _createElement('li', {
            'className': 'cm_sort-dialog_list-item' + (currentSort === sortOption ? ' cm_sort-dialog_list-item_active' : ''),
            'onClick': e => window.Convermax.handleSortDialogOptionClick(e, sortOption)
        }, _createElement('svg', {
            'className': 'cm_sort-dialog_icon-inactive',
            'width': '20',
            'height': '20',
            'viewBox': '0 0 20 20',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg'
        }, _createElement('rect', {
            'x': '0.5',
            'y': '0.5',
            'width': '19',
            'height': '19',
            'rx': '9.5',
            'fill': 'white',
            'stroke': '#666768'
        })), _createElement('svg', {
            'className': 'cm_sort-dialog_icon-active',
            'width': '20',
            'height': '20',
            'viewBox': '0 0 20 20',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg'
        }, _createElement('rect', {
            'x': '0.5',
            'y': '0.5',
            'width': '19',
            'height': '19',
            'rx': '9.5',
            'fill': '#000104',
            'stroke': '#000104'
        }), _createElement('rect', {
            'x': '6',
            'y': '6',
            'width': '8',
            'height': '8',
            'rx': '4',
            'fill': 'white'
        })), '\n\n        ', _translate(`sort_option_${ sortOption.replace(':', '_') }`), '\n      ');
    }
    function scopeCurrentSort2() {
        var currentSort = window.Convermax.getSearchSort();
        return _createElement.apply(this, [
            'ul',
            { 'className': 'dialog-body cm_sort-dialog_list' },
            _map(window.Convermax.sortFields, repeatSortOption1.bind(this, currentSort))
        ]);
    }
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-header' }, _createElement('div', { 'className': 'dialog-title-container' }, _createElement('div', { 'className': 'dialog-title' }, 'Sort By'), _createElement('div', {
        'className': 'close',
        'data-cm-role': 'close'
    }, _createElement('svg', {
        'xmlns': 'http://www.w3.org/2000/svg',
        'width': '20',
        'height': '20',
        'viewBox': '0 0 20 20',
        'fill': 'none'
    }, _createElement('path', {
        'd': 'M0.625 0.625L18.625 18.625',
        'stroke': 'white',
        'strokeWidth': '1.25',
        'strokeLinecap': 'round',
        'strokeLinejoin': 'round'
    }), _createElement('path', {
        'd': 'M18.625 0.625L0.625 18.625',
        'stroke': 'white',
        'strokeWidth': '1.25',
        'strokeLinecap': 'round',
        'strokeLinejoin': 'round'
    }))))), scopeCurrentSort2.apply(this, []), _createElement('div', { 'className': 'buttons-container' }, _createElement('div', {
        'className': 'cm_button cm_facet-dialog_button-clear btn btn-secondary',
        'onClick': () => window.Convermax.handleSortDialogClearClick()
    }, '\n        ', _translate(`facet_dialog_clear`), '\n      '), _createElement('div', {
        'className': 'cm_button cm_facet-dialog_button-done btn btn-primary',
        'data-cm-role': 'close'
    }, '\n        ', _translate(`facet_dialog_done`), '\n      '))));
}
        export const componentNames = []